module.exports = __webpack_public_path__ + "static/img/client5.63658f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client5.png
// module id = gy70
// module chunks = 1